module.exports = __webpack_public_path__ + "d56420e87cfffdd5fe595a5f1fd2bfc3.png";